// extracted by mini-css-extract-plugin
module.exports = {"c-popular-block-wrap":"_025a50318d--c-popular-block-wrap--3Vivp"};